import { api } from "../../../api";
import { WhsDeliveryListResponse, RequestWhsDeliveryParams } from "../types";

export async function getWhsDeliveryListApi(
  params: RequestWhsDeliveryParams,
): Promise<WhsDeliveryListResponse> {
  const { data } = await api.get<WhsDeliveryListResponse>(`/api/delivery-whs`, {
    params,
  });
  return data;
}

export async function exportWhsDeliveryApi(
  params?: Partial<RequestWhsDeliveryParams>,
): Promise<{
  file: Blob;
  filename: string;
}> {
  const response = await api.get(`/api/delivery-whs/export`, {
    params,
    responseType: "blob",
  });
  const disposition = response.headers["content-disposition"];
  let filename = "downloaded_file";
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = decodeURIComponent(match[1]);
    }
  }

  return { file: response.data, filename };
}
